import { isEmpty } from 'lodash';
export const directionSet = (data) => {
    let directions = [];
    if (!isEmpty(data)) {
        const { choose, vertical } = data;
        const reverseData = [...vertical].reverse();
        if (choose === 0) {
            directions = [...reverseData];
        }
        else {
            directions = [...vertical];
        }
    }
    return directions;
};
